import React, { useState } from "react";
import ProfileDetails from "./ProfileDetails";
import SubscriptionDetails from "./UserSubscriptionDetails";
import { Helmet } from "react-helmet";
import { useTheme } from "../../ThemeProvider/ThemeContext";
import "../Common/eaPage.css";

const TABS = [
  { key: "profile", label: "Profile" },
  { key: "subscription", label: "Subscription" },
];

function UserProfile() {
  const { isDark } = useTheme();
  const [activeTab, setActiveTab] = useState("profile");

  return (
    <>
      <Helmet>
        <title>Profile | EMAlpha</title>
      </Helmet>
      <div className={`ea-page${isDark ? " is-dark" : ""}`}>
        <div className="ea-shell">
          <header className="ea-head">
            <p className="ea-eyebrow">Account</p>
            <h1 className="ea-title">Profile & subscription</h1>
          </header>

          <div className="ea-tabs" role="tablist">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.key}
                className={`ea-tab${activeTab === tab.key ? " is-active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {activeTab === "profile" ? <ProfileDetails /> : <SubscriptionDetails />}
        </div>
      </div>
    </>
  );
}

export default UserProfile;
